import { Directive, input } from '@angular/core';

/**
 * interfaces
 */
import { ITableTreeRowNode } from '../../interfaces';

/**
 * Marks a body `<tr>` of an `app-tree-table` as a tree row.
 *
 * It publishes the row's depth as `--app-table-tree-depth`, which indents the
 * row's `app-table-tree-toggler` (and anything else in the row that reads it).
 *
 * It sets no `aria-level` / `aria-expanded`: those are valid on a row only
 * inside a `treegrid`, and the tree table renders a plain table. The row's
 * expandable state is announced by its toggler button.
 */
@Directive({
    selector: 'tr[appTableTreeRow]',
    host: {
        '[style.--app-table-tree-depth]': 'appTableTreeRow().depth',
    },
})
export class TableTreeRowDirective {

    public readonly appTableTreeRow = input.required<ITableTreeRowNode<unknown>>();
}
